import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AuthTokenService } from '../services/auth-token.service';
import { catchError, map, Observable, of, take } from 'rxjs';
import { Store } from '@ngrx/store';
import { silentClearSession } from '../state/auth/auth.actions';

@Injectable({ providedIn: 'root' })
export class GuestGuard implements CanActivate {
  private readonly allowWithExistingSessionPrefixes = [
    '/verify-email',
    '/confirm-email-change',
    '/reset-password',
  ];

  constructor(
    private authTokenService: AuthTokenService,
    private router: Router,
    private store: Store
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const shouldBypassSessionRedirect = this.allowWithExistingSessionPrefixes.some((prefix) =>
      state.url.startsWith(prefix)
    );

    if (shouldBypassSessionRedirect) {
      return of(true);
    }

    const token = this.authTokenService.getToken();

    if (!token) return of(true);

    if (this.authTokenService.isAuthenticated()) {
      return this.authTokenService.refresh().pipe(
        map(({ accessToken }) => {
          this.authTokenService.storeToken(accessToken);
          this.router.navigate(['/meal-planner']);
          return false;
        }),
        catchError((error) => {
          if (error?.error?.code === 'WEB_PORTAL_ACCESS_DENIED') {
            this.authTokenService.clearToken();
            this.store.dispatch(silentClearSession());
            this.router.navigate(['/download']);
            return of(false);
          }

          this.router.navigate(['/meal-planner']);
          return of(false);
        })
      );
    }

    return this.authTokenService.refresh().pipe(
      map(({ accessToken }) => {
        this.authTokenService.storeToken(accessToken);
        this.router.navigate(['/meal-planner']);
        return false;
      }),
      catchError((error) => {
        if (error?.error?.code === 'WEB_PORTAL_ACCESS_DENIED') {
          this.authTokenService.clearToken();
          this.store.dispatch(silentClearSession());
          this.router.navigate(['/download']);
          return of(false);
        }

        this.authTokenService.clearToken();
        this.store.dispatch(silentClearSession());
        return of(true); // still allow guest route
      })
    );
  }
}


